<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Gened Application Login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="username"
                    label="Enter username"
                    prepend-icon="account_circle"
                    required
                    @keyup.enter="submit"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    prepend-icon="vpn_key"
                    :append-icon="show ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    name="password"
                    label="Enter password"
                    hint="At least 8 characters"
                    counter
                    @click:append="show = !show"
                    @keyup.enter="submit"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading" @click.native="submit">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <template>
            <v-snackbar
              :timeout="timeout"
              :color="color"
              :multi-line="mode === 'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbar"
            >
              {{ text }}
              <v-btn dark flat @click.native="snackbar = false">ปิด</v-btn>
            </v-snackbar>
          </template>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import 'vuetify/dist/vuetify.min.css'
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
      show: false,
			/*username: 'admin',
			password: 'password',*/
			username: null,
			password: null,
			loading: false,
			isVisible: true,
     	snackbar: false,
      timeout: 5000,
      mode: '',
      color: 'error',
      text: '',
      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => ('The email and password you entered don\'t match')
        }
		}
	},
	methods: {
		submit() {
			this.loading = true
			console.log('Login...')
      this.$store.dispatch("login", {
        user: {
          username: this.username,
          password: this.password
        }
      }).then(() => {
        this.$router.push("/")
      }, (error) => {
      	setTimeout(() => this.loading = false, 500)
        let msg
        if(error.response.status >= 500) {
        	msg = '['+error.response.status+'] ล้มเหลวในการเชื่อมต่อเซิร์ฟเวอร์'
        } else {
        	msg = 'ล๊อกอินไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่านอีกครั้ง'
        }
        this.text = msg
        this.snackbar = true
      })

		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/login.vue